/**
 * @desc list
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.inDetailBox.list.Params, options?: any) {
  return updateResponse(
    http(URL + `/inDetailBox`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
